import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const SMS_CoursesOffered = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.coursesOffered, setData);
  }, [currentDomain]);

  // Function to render rich text content
  const renderRichText = (content) => {
    if (!content || !Array.isArray(content)) return null;
    
    return content.map((block, index) => {
      if (block.type === 'paragraph') {
        return (
          <p key={index} style={{ marginBottom: '15px', lineHeight: '1.6' }}>
            {block.children?.map((child, childIndex) => (
              <span key={childIndex} style={{ fontWeight: child.bold ? 'bold' : 'normal' }}>
                {child.text}
              </span>
            ))}
          </p>
        );
      } else if (block.type === 'heading') {
        const HeadingTag = `h${block.level}`;
        return React.createElement(
          HeadingTag,
          {
            key: index,
            style: {
              marginBottom: '12px',
              marginTop: '20px',
              color: '#ff6600',
              fontSize: `calc(${fontSize}px + ${6 - block.level}px)`,
              fontWeight: 'bold'
            }
          },
          block.children?.map((child, childIndex) => (
            React.createElement('span', {
              key: childIndex,
              style: { fontWeight: child.bold ? 'bold' : 'normal' }
            }, child.text)
          ))
        );
      } else if (block.type === 'list') {
        const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
        return React.createElement(
          ListTag,
          {
            key: index,
            style: {
              marginBottom: '15px',
              paddingLeft: '20px',
              lineHeight: '1.6'
            }
          },
          block.children?.map((listItem, listIndex) => (
            React.createElement(
              'li',
              {
                key: listIndex,
                style: {
                  marginBottom: '8px',
                  color: '#333'
                }
              },
              listItem.children?.map((child, childIndex) => (
                React.createElement('span', {
                  key: childIndex,
                  style: { fontWeight: child.bold ? 'bold' : 'normal' }
                }, child.text)
              ))
            )
          ))
        );
      }
      return null;
    });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Courses Offered | SMS | JNTU Anantapur</title>
        <meta
          name="description"
          content="Courses offered at School of Management Studies, JNTUA - MBA Programs and other management courses"
        />
        <meta
          name="keywords"
          content="Courses, MBA, SMS, School of Management Studies, JNTUA, Programs, Management"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .course-card {
                        border: 1px solid #ddd;
                        border-radius: 12px;
                        overflow: hidden;
                        margin-bottom: 30px;
                        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    
                    .course-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 15px rgba(0,0,0,0.15);
                    }
                    
                    .course-header {
                        background: linear-gradient(135deg, #ff6600, #ff8533);
                        color: white;
                        padding: 20px;
                        text-align: center;
                    }
                    
                    .course-name {
                        font-size: calc(${fontSize}px + 8px);
                        font-weight: bold;
                        margin: 0 0 10px 0;
                    }
                    
                    .course-details {
                        display: flex;
                        justify-content: space-around;
                        margin-top: 10px;
                    }
                    
                    .course-detail-item {
                        text-align: center;
                        font-size: calc(${fontSize}px - 1px);
                    }
                    
                    .course-detail-label {
                        display: block;
                        font-weight: 500;
                        opacity: 0.9;
                    }
                    
                    .course-detail-value {
                        display: block;
                        font-weight: bold;
                        margin-top: 2px;
                    }
                    
                    .course-body {
                        padding: 25px;
                    }
                    
                    .course-section {
                        margin-bottom: 25px;
                    }
                    
                    .course-section-title {
                        font-size: calc(${fontSize}px + 4px);
                        font-weight: bold;
                        color: #ff6600;
                        margin-bottom: 15px;
                        border-bottom: 2px solid #ff6600;
                        padding-bottom: 8px;
                        display: inline-block;
                    }
                    
                    .course-content {
                        color: #333;
                        line-height: 1.7;
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Courses Offered"
          pageName="Courses Offered"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">
                      {data?.data?.attributes?.title || "Courses Offered"}
                    </h3>
                    
                    {data?.data?.attributes?.description && (
                      <div className="mb-4" style={{ padding: "20px", backgroundColor: "#f8f9fa", borderLeft: "4px solid #ff6600", borderRadius: "4px" }}>
                        <p style={{ margin: "0", lineHeight: "1.6", color: "#333", fontSize: "16px" }}>
                          {data.data.attributes.description}
                        </p>
                      </div>
                    )}
                    
                    {data?.data?.attributes?.courses?.length > 0 ? (
                      data.data.attributes.courses.map((course, index) => (
                        <div key={course.id || index} className="course-card">
                          <div className="course-header">
                            <h4 className="course-name">{course.name}</h4>
                            {(course.duration || course.mode) && (
                              <div className="course-details">
                                {course.duration && (
                                  <div className="course-detail-item">
                                    <span className="course-detail-label">Duration</span>
                                    <span className="course-detail-value">{course.duration}</span>
                                  </div>
                                )}
                                {course.mode && (
                                  <div className="course-detail-item">
                                    <span className="course-detail-label">Mode</span>
                                    <span className="course-detail-value">{course.mode}</span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          
                          <div className="course-body">
                            {course.introduction && (
                              <div className="course-section">
                                <h5 className="course-section-title">Course Details</h5>
                                <div className="course-content">
                                  {renderRichText(course.introduction)}
                                </div>
                              </div>
                            )}
                            
                            {course.objective && (
                              <div className="course-section">
                                <h5 className="course-section-title">Objective</h5>
                                <div className="course-content">
                                  {renderRichText(course.objective)}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center" style={{ padding: "60px 20px" }}>
                        <div style={{ color: "#666", fontSize: "16px" }}>
                          <i className="fas fa-graduation-cap" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          No courses information available at the moment.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMS_CoursesOffered;